/* eslint-disable @nx/enforce-module-boundaries */
import { AdddCircleIcon } from '@mybridge/icons';
import { useDisclosure, useOutsideClick } from '@mybridge/ui/hooks';
import { Input, InputGroup, InputRightElement } from '@mybridge/ui/input';
import { HStack } from '@mybridge/ui/layout';
import { List, ListItem } from '@mybridge/ui/list';
import {
  Popover,
  PopoverBody,
  PopoverContent,
  PopoverTrigger,
} from '@mybridge/ui/popover';
import { Spinner } from '@mybridge/ui/spinner';
import { Text } from '@mybridge/ui/text';
import { useEffect, useMemo, useRef, useState } from 'react';
import { useSkills } from 'v4/lib/hooks/use-skills';
import { CustomDropdown } from '../custom-dropdown';

export const SkillsDropdown = ({ ...props }) => {
  const [search, setSearch] = useState();
  const { data, createLoading, mutateAsync, isLoading } = useSkills({
    search,
  });

  const skills = useMemo(
    () => data?.pages?.reduceRight?.((ac, p) => ac.concat(p?.results), []),
    [data?.pages]
  );

  const handleCreateItem = async (val) => {
    try {
      const resp = await mutateAsync({ name: val });
      if (resp) {
        props.onChange?.(resp);
      } else {
        props.onChange?.({ name: val });
      }
    } catch (e) {
      console.error(e);
      props.onChange?.({ name: val });
    }
  };

  return (
    <CustomDropdown
      {...props}
      data={skills}
      isLoading={isLoading}
      onSearch={(s) => setSearch(s)}
      onCreateItem={handleCreateItem}
      createLoading={createLoading}
    />
  );
};
